// import { Modal, Button, Result } from "antd";
// import { useNavigate } from "react-router-dom";

// // Modal encargado de ejecutar callback de nueva reubicacion o auditoria y mostrar resultado
// const ActionResultModal = ({
//   open,
//   onClose,
//   type = "success",
//   message = "",
//   orden = null,
//   modalType = null, // 'reubicacion' o 'auditoria'
// }) => {
//   const navigate = useNavigate();

//   const getActionButtonText = () => {
//     if (modalType === "reubicacion") return "Ir a la reubicación";
//     if (modalType === "auditoria") return "Ir a la auditoría";
//     return "Ir a la orden";
//   };

//   const handleNavigate = () => {
//     if (!orden) return;
//     const path =
//       modalType === "auditoria"
//         ? `/auditorias/${orden}`
//         : `/reubicaciones/${orden}`;
//     navigate(path);
//     onClose();
//   };

//   return (
//     <Modal
//       open={open}
//       onCancel={onClose}
//       footer={
//         type === "success" && orden ? (
//           <Button
//             onClick={handleNavigate}
//             type="primary"
//             style={{
//               backgroundColor: "#52c41a",
//               borderColor: "#52c41a",
//               color: "#fff",
//             }}
//           >
//             {getActionButtonText()}
//           </Button>
//         ) : null
//       }
//     >
//       <Result status={type} title={message} />
//     </Modal>
//   );
// };

// export default ActionResultModal;

import { Modal, Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const ActionResultModal = ({
  open,
  onClose,
  type = "success",
  message = "",
  orden = null,
  modalType = null, // 'reubicacion' o 'auditoria'
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (open && type === "success" && modalType === "reubicacion" && orden) {
      navigate(`/reubicaciones/${orden}`);
      onClose();
    }
  }, [open, type, modalType, orden, navigate, onClose]);

  const getActionButtonText = () => {
    if (modalType === "reubicacion") return "Ir a la reubicación";
    if (modalType === "auditoria") return "Ir a la auditoría";
    return "Ir a la orden";
  };

  const handleNavigate = () => {
    if (!orden) return;
    const path =
      modalType === "auditoria"
        ? `/auditorias/${orden}`
        : `/reubicaciones/${orden}`;
    navigate(path);
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={
        type === "success" && orden && modalType !== "reubicacion" ? (
          <Button
            onClick={handleNavigate}
            type="primary"
            style={{
              backgroundColor: "#52c41a",
              borderColor: "#52c41a",
              color: "#fff",
            }}
          >
            {getActionButtonText()}
          </Button>
        ) : null
      }
    >
      <Result status={type} title={message} />
    </Modal>
  );
};

export default ActionResultModal;
